import React from "react";
import { Locale } from "@linkfluence/models/locale";
import { Glyph } from "@ui-kit/icon";
import Content from "./content";
import Footer, { CustomButton } from "./footer";
import Root from "./root";
export type { CustomButton } from "./footer";

interface IProps {
  // Embeded elements
  children?: React.ReactNode;
  // Action when click on Ok button
  onValidate?: () => void;
  // Label for close footer
  validateLabel?: string;
  // Action when click on close
  onCancel?: () => void;
  // Label for close footer
  cancelLabel?: string;
  // Custom footer and actions (override validate and close)
  customButtons?: CustomButton[];
  // Big illustration in header
  drawing?: Glyph;
  // Modal title
  title?: string | React.ReactNode;
  // Description text
  description?: string;
  // Help text
  help?: string;
  // A bold warning message
  warning?: React.ReactNode;
  // Replaces whole content, except close icon
  customContent?: React.ReactNode;
  // If false, validate button is disabled
  isValid?: boolean;
  locale: Locale;
  // Force width
  width?: number | string;
  // Remove max width of 757px
  fullWidth?: boolean;
  displayFooter?: boolean;
  invalidText?: string;
  height?: number;
}

const UiKitModal = ({
  children,
  onCancel,
  drawing,
  title,
  description,
  warning,
  help,
  customContent,
  width = 650,
  fullWidth,
  displayFooter = true,
  height,
  ...props
}: IProps) => (
  <Root onClose={onCancel} width={width} fullWidth={fullWidth} height={height}>
    {customContent || (
      <>
        <Content
          customContent={customContent}
          drawing={drawing}
          title={title}
          description={description}
          warning={warning}
          help={help}
        >
          {children}
        </Content>
        {displayFooter && <Footer {...props} onCancel={onCancel} />}
      </>
    )}
  </Root>
);

export default UiKitModal;
